import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { RouteData } from '../../../shared/models/route-data.model';
import { filter, Subject, takeUntil } from 'rxjs';
import { TitleService } from '../../../shared/services/title.service';
import { AuthService } from '../../../shared/services/auth.service';
import { User } from '../../../modules/admin/models/user.model';

@Component({
  selector: 'app-header',
  standalone: false,
  
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {

  title = '';  
  private destroyed$ = new Subject<void>();

  constructor(private titleService: TitleService, protected authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    this.titleService.title$
    .pipe(
      takeUntil(this.destroyed$)
    )
    .subscribe(title => {
      this.title = title;
    });    
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  get isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }
}